// AI进宝
import { PAGE_LEVEL } from '@/constants';
import { beforeEnterOpenChatHome } from '@/pages/aiAssistant/utils/openChatModeRestore';

const IRM_EMBED_SOURCE = 'irm';
const IRM_THIRD_PARTY_AI_CHAT_PATHS = {
  aiChatIndex: '/thirdparty/comeinAichat/index',
  aiChatList: '/thirdparty/comeinAichat/list',
  aiChatHistory: '/thirdparty/comeinAichat/history',
  aiChatResearchBrainManage: '/thirdparty/comeinAichat/researchBrainManage'
};

function redirectIrmEmbedToThirdParty(to) {
  if (to.query?.source !== IRM_EMBED_SOURCE) return true;

  return {
    path: IRM_THIRD_PARTY_AI_CHAT_PATHS[to.name] || IRM_THIRD_PARTY_AI_CHAT_PATHS.aiChatIndex,
    query: { ...to.query },
    replace: true
  };
}

export default {
  meta: {
    localeModules: [
      'aiChat',
      'aiAssistant',
      'researchEditor',
      'aiChatConstants',
      'aiTools',
      'openClaw',
      'cloudDocument',
      'report',
      'summary',
      'comment',
      'daily',
      'eventSignal',
      'roadshow',
      'aiDataUsage'
    ],
    title: 'routers.ai_chat_ai_jinbao'
  },
  // AI进宝
  path: '/aiChat',
  redirect: '/aiChat/index',
  component: () => import(/* webpackChunkName: 'ai-chat' */ '@/pages/aiAssistant/chatMode/index'),
  beforeEnter: redirectIrmEmbedToThirdParty,
  children: [
    {
      path: 'index',
      name: 'aiChatIndex',
      component: () => import(/* webpackChunkName: 'ai-chat-index' */ '@/pages/aiAssistant/chatMode/chatHome'),
      // 进入 AI 进宝首页前，按"上次停留模式"在路由层直接恢复到研究/任务模式，避免聊天首页空白闪烁
      beforeEnter: beforeEnterOpenChatHome,
      meta: {
        name: 'routers.ai_chat_ai_jinbao',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: false,
        hideBreadcrumb: true,
        // AI进宝三模式（聊天/研究/任务）共用同一个客户端顶部tab
        tabGroup: '/aiChat/index'
      }
    },
    {
      path: 'list',
      name: 'aiChatList',
      component: () => import(/* webpackChunkName: 'ai-chat-list' */ '@/pages/aiAssistant/chatMode/chatList'),
      meta: {
        name: 'routers.ai_chat_ai_jinbao',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/aiChat/index',
        keepAlive: false,
        hideBreadcrumb: true,
        electronSingle: true,
        agentModuleConfig: ['业绩观点']
      }
    },
    {
      path: 'history',
      name: 'aiChatHistory',
      component: () => import(/* webpackChunkName: 'ai-chat-history' */ '@/pages/aiAssistant/chatMode/chatHistory'),
      meta: {
        name: 'routers.ai_chat_ai_jinbao_history',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/aiChat/index',
        keepAlive: false,
        hideBreadcrumb: true,
        electronSingle: true
      }
    },
    {
      path: 'researchBrainManage',
      name: 'aiChatResearchBrainManage',
      component: () =>
        import(/* webpackChunkName: 'ai-chat-history' */ '@/pages/aiAssistant/chatMode/researchBrainManage'),
      meta: {
        name: 'routers.ai_chat_research_brain_manage',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/aiChat/index',
        keepAlive: false,
        hideBreadcrumb: true,
        electronSingle: true
      }
    }
  ]
};
